/* @flow */
import { OrderedMap } from 'immutable';
import { combineReducers } from 'redux-immutable';
import createDebugger from 'debug';
import type { Action } from 'trustar/utils/redux-types.js';

const debug = createDebugger('app:modules:groups:stores'); // eslint-disable-line no-unused-vars

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  EDIT,
  EDIT_SUCCESS,
  EDIT_FAILURE,
  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,
} from './action-types.js';
import type { SharingGroupState } from './types.js';

export const sharingGroups = (state: SharingGroupState = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
    return payload;
  case DELETE_SUCCESS:
    return state.delete(payload); // The ID to be deleted
  case SAVE_SUCCESS:
  case EDIT_SUCCESS:
    return state.set(payload.get('guid'), payload);
  default:
    return state;
  }
};

export const loading = (state: boolean = false, action: Action<*>) => {
  switch (action.type) {
  case FETCH:
  case SAVE:
  case EDIT:
  case DELETE:
    return true;
  case FETCH_SUCCESS:
  case SAVE_SUCCESS:
  case EDIT_SUCCESS:
  case DELETE_SUCCESS:
  case FETCH_FAILURE:
  case SAVE_FAILURE:
  case EDIT_FAILURE:
  case DELETE_FAILURE:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  sharingGroups,
  loading,
});



// WEBPACK FOOTER //
// ./src/app/modules/groups/stores.js